var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from "axios";
import { ApiResponseCode } from "@/ts/enums/ApiResponseCode";
/**
 * @description service to call HTTP request via Axios
 * Manager 페이지의 ApiService를 커스텀
 */
var ApiService = /** @class */ (function () {
    /**
     * @description initialize vue axios
     */
    function ApiService() {
        /**
         * @description property to share vue instance
         */
        this.axiosInstance = axios;
        this.setHeader();
        this.setInterceptors();
    }
    /**
     * @description set the default HTTP request headers
     */
    ApiService.prototype.setHeader = function () {
        var token = this.getToken();
        this.axiosInstance.defaults.headers.common["Authorization"] = "Bearer ".concat(token);
        this.axiosInstance.defaults.headers.common["Accept"] =
            "application/json";
        this.axiosInstance.defaults.headers.common['App-Language'] = this.getLang();
    };
    ApiService.prototype.getLang = function () {
        var app_language = document.head.querySelector('meta[name="App-Language"]');
        if (app_language) {
            console.log("app_language", app_language.content);
            return app_language.content;
        }
        else {
            console.warn('app language header can not found');
            return 'ko';
        }
    };
    ApiService.prototype.getToken = function () {
        var headerToken = document.head.querySelector('meta[name="App-Access-Token"]');
        return headerToken.content;
    };
    ApiService.prototype.setToken = function (token) {
        console.log("set new Toekn to header");
        this.axiosInstance.defaults.headers.common['Authorization'] = "Bearer ".concat(token);
        var headerToken = document.head.querySelector('meta[name="App-Access-Token"]');
        headerToken.content = token;
    };
    ApiService.prototype.setInterceptors = function () {
        var _this = this;
        // 응답 인터셉터 - access_token 만료 시 refresh 로직
        this.axiosInstance.interceptors.response.use(function (response) { return response; }, function (error) { return __awaiter(_this, void 0, void 0, function () {
            var originalRequest, code, res, newAccessToken, refreshError_1;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        console.log(error);
                        originalRequest = error.config;
                        code = (_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.code;
                        // 401 에러이며 재시도하지 않은 요청일 경우만 처리
                        console.log(((_c = error.response) === null || _c === void 0 ? void 0 : _c.status) === 401, code, !originalRequest._retry);
                        if (!(((_d = error.response) === null || _d === void 0 ? void 0 : _d.status) === 401 && code === ApiResponseCode.TOKEN_EXPIRED && !originalRequest._retry)) return [3 /*break*/, 4];
                        originalRequest._retry = true;
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.axiosInstance.post("".concat(process.env.MIX_API_HOST, "/auth/refresh"), {})];
                    case 2:
                        res = _e.sent();
                        newAccessToken = res.data.data.access_token;
                        // 저장하고 원래 요청에 다시 붙여서 재시도
                        localStorage.setItem('access_token', newAccessToken);
                        this.setToken(newAccessToken);
                        originalRequest.headers['Authorization'] = "Bearer ".concat(newAccessToken);
                        return [2 /*return*/, this.axiosInstance(originalRequest)];
                    case 3:
                        refreshError_1 = _e.sent();
                        // 재발급 실패 시 강제 로그아웃 또는 알림
                        console.error('토큰 재발급 실패:', refreshError_1);
                        localStorage.removeItem('access_token');
                        localStorage.removeItem('refresh_token');
                        // window.location.href = '/login'; // 또는 custom alert
                        return [2 /*return*/, Promise.reject(refreshError_1)];
                    case 4: return [2 /*return*/, Promise.reject(error)];
                }
            });
        }); });
    };
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    ApiService.prototype.query = function (resource, params) {
        return this.axiosInstance.get(resource, params);
    };
    /**
     * @description send the GET HTTP request
     * @param resource: string
     * @param slug: string
     * @returns Promise<AxiosResponse>
     */
    ApiService.prototype.get = function (resource, slug) {
        if (slug === void 0) { slug = ""; }
        return this.axiosInstance.get("".concat(resource, "/").concat(slug));
    };
    /**
     * @description set the POST HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    ApiService.prototype.post = function (resource, params) {
        return this.axiosInstance.post("".concat(resource), params);
    };
    /**
     * @description send the UPDATE HTTP request
     * @param resource: string
     * @param slug: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    ApiService.prototype.update = function (resource, slug, params) {
        return this.axiosInstance.put("".concat(resource, "/").concat(slug), params);
    };
    /**
     * @description Send the PUT HTTP request
     * @param resource: string
     * @param params: AxiosRequestConfig
     * @returns Promise<AxiosResponse>
     */
    ApiService.prototype.put = function (resource, params) {
        return this.axiosInstance.put("".concat(resource), params);
    };
    /**
     * @description Send the DELETE HTTP request
     * @param resource: string
     * @returns Promise<AxiosResponse>
     */
    ApiService.prototype.delete = function (resource) {
        return this.axiosInstance.delete(resource);
    };
    return ApiService;
}());
export default new ApiService;
